import {
  GroupOutlinedIcon,
  HistoryIcon,
  ManageAccountsOutlinedIcon,
  type SvgIcon,
} from '@shared/components';

import { type SidebarIcon } from './types/sidebar';

export const MENU_DRAWER_WIDTH_LARGE = 240;
export const MENU_DRAWER_WIDTH_SMALL = 80;

export const MENU_ICONS: Record<SidebarIcon, typeof SvgIcon> = {
  users: GroupOutlinedIcon,
  roles: ManageAccountsOutlinedIcon,
  logs: HistoryIcon,
};
